module.exports = __webpack_public_path__ + "static/example-ff1616ec820739599e156d73a7a4cd95.png";